import React from 'react';
import {HashLink as Link} from 'react-router-hash-link';
import PropTypes from 'prop-types';
import "./testimonial.css"

const TestimonialCard = ({
                             id,
                             imageSrc,
                             name,
                             subText,
                             excerpt,
                             scrollSnapAlign = 'start',
                             flexBasis = '33%'
                         }) => {
    return (
        <div
            className="testimonial-dtail"
            style={{
                scrollSnapAlign,
                flex: `0 0 ${flexBasis}`
            }}
        >
            <div className="testimonial-image">
                <Link to={`/testimonial#${id}`} smooth>
                    <img src={imageSrc} alt={name}/>
                </Link>
            </div>
            <div className="testimonial-text">
                <h5 className='fw-bold text-start mt-3'>
                    {name}
                </h5>
                <h6 className='text-start mb-4'>
                    <strong>{subText}</strong>
                </h6>
                <p>
                    "{excerpt}"
                </p>
                <Link to={`/testimonial#${id}`} smooth>
                    <button type="button" className="btn">View Story</button>
                </Link>
            </div>
        </div>
    );
};

TestimonialCard.propTypes = {
    id: PropTypes.string.isRequired,
    imageSrc: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    subText: PropTypes.string.isRequired,
    excerpt: PropTypes.string.isRequired,
    scrollSnapAlign: PropTypes.string,
    flexBasis: PropTypes.string
};

export default TestimonialCard;
